<template>
  <tile-basic
    class="is-info"
    :title="title"
    :values="keyValues(profile)"
    :link="profileLink"
    headerImg="profile">
      <div slot="bottom" class="pie">
        <chart-analytics-pie
          v-if="chart && profile.analytics.length > 0"
          slot="bottom"
          :analytics="profile.analytics" >
        </chart-analytics-pie>
      </div>
  </tile-basic>
</template>

<script>
import mixin from '@/mixins/profiles';
import ChartAnalyticsPie from '@/components/charts/ChartAnalyticsPie.vue';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'TileProfile',
  mixins: [mixin],
  components: {
    ChartAnalyticsPie,
    TileBasic,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    link: {
      default: null,
    },
    chart: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Profile Summary',
    },
  },
  computed: {
    profileLink() {
      if (this.link === null) {
        return {
          name: 'profiles.index.detail',
          params: { id: this.profile.id },
        };
      }
      return this.link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.paddding {
  padding: 1rem;
}

.info {
  margin-bottom: 0;
}

.pie {
  // min-height: 250px;
}

</style>
